<div class="loading">
  <span><mat-spinner color="primary" diameter="80"></mat-spinner></span>
</div>
